export default "__VITE_ASSET__CyjJ8qiO__"